import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/service/alert.service';
import { ClientesService } from 'src/app/service/clientes.service';
import { LicencasService } from 'src/app/service/licencas.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { EscolherUsuarioEnviarTokenComponent } from '../escolher-usuario-enviar-token/escolher-usuario-enviar-token.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-alterar-licenca-adquirida',
  templateUrl: './alterar-licenca-adquirida.component.html',
  styleUrls: ['./alterar-licenca-adquirida.component.css']
})
export class AlterarLicencaAdquiridaComponent implements OnInit {

  public licencaForm: FormGroup = this.formBuilder.group({
    fk_licenca: ['', Validators.required],
    fk_cliente: ['', Validators.required],
    ts_ativacao: ['', Validators.required],
    it_dias_duracao: ['', Validators.required],
    ts_expiracao: [''],
    select_opcoes: [''],
    vc_ordem_servico: [''],
    vc_nota_fiscal: [''],
    vc_proposta: [''],
    vc_alvo_tecnico_cancelamento: [''],
  });
  
  public licencas: any = [];
  public usinas: any = [];
  public tipoAlteracao = this.activatedRoute.snapshot.paramMap.get('tipoAlteracao')!;
  public campos: any = [];
  public dataMinima = new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-');
  public desabilitadoIdentificadorLicenca: boolean = false;
  public desabilitadoLicenca: boolean = true;
  public desabilitadoUsina: boolean = true;
  public desabilitarDataAtiv: boolean = true;
  public desabilitarJs: boolean = true;
  public licencaAdquirida: any;
  public campoSelecionado: string = ''; 
  public camposFiltrados: any = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private licencaService: LicencasService,
    private serviceClientes: ClientesService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.listarLicenca();
    this.listarClientes();
    this.popularForm();
    this.setarDataExpiracao();
    this.filtrarCampos();
  }

  cancel() {
    this.router.navigate(['configuracao/licencas']);
  }

  listarLicenca() {
    this.licencaService.listarLicencaComCampos().subscribe((licencasResposta: any) => {
      this.licencas = licencasResposta;
    });
  }

  listarClientes() {
    this.serviceClientes.listarServiceClientes().subscribe((resp) => {
      this.usinas = resp;
    });
  }

  popularForm(): void  {
    this.activatedRoute.queryParams.subscribe((licencaAdquirida: any) => {
      this.licencaAdquirida = licencaAdquirida
      if (this.tipoAlteracao == 'Renovar') {
        this.licencaForm.setValue({
          fk_licenca: licencaAdquirida.fk_licenca,
          fk_cliente: licencaAdquirida.fk_cliente,
          ts_ativacao: licencaAdquirida.ts_expiracao?.substring(0, 10) || '',
          it_dias_duracao: licencaAdquirida.it_dias_duracao || '',
          vc_ordem_servico: licencaAdquirida.vc_ordem_servico || '',
          vc_proposta: licencaAdquirida.vc_proposta || '',
          vc_nota_fiscal: licencaAdquirida.vc_nota_fiscal || '',
          vc_alvo_tecnico_cancelamento: licencaAdquirida.vc_alvo_tecnico_cancelamento || '',

          ts_expiracao: this.calcularDataExpiracao(
            licencaAdquirida.it_dias_duracao,
            licencaAdquirida.ts_expiracao
          ),
          select_opcoes: ''
        });
      } else if (this.tipoAlteracao == 'Trocar') {  
        var diasRestantesDaLicenca = this.calcularDiasRestantesDaLicenca(
          new Date(licencaAdquirida.ts_ativacao),
          new Date(),
          licencaAdquirida.it_dias_duracao
        );
      
        this.licencaForm.setValue({ 
          fk_licenca: licencaAdquirida.fk_licenca || '',
          fk_cliente: licencaAdquirida.fk_cliente || '',
          ts_ativacao: new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-'),
          it_dias_duracao: diasRestantesDaLicenca || '',
          vc_ordem_servico: licencaAdquirida.vc_ordem_servico || '',
          vc_proposta: licencaAdquirida.vc_proposta || '',
          vc_nota_fiscal: licencaAdquirida.vc_nota_fiscal || '',
          vc_alvo_tecnico_cancelamento: licencaAdquirida.vc_alvo_tecnico_cancelamento || '',
          ts_expiracao: this.calcularDataExpiracao(
            licencaAdquirida.it_dias_duracao,
            licencaAdquirida.ts_expiracao
          ) || '',
          select_opcoes: ''
        });
      } else if (this.tipoAlteracao == 'Editar') {  
        var diasRestantesDaLicenca = this.calcularDiasRestantesDaLicenca(
          new Date(licencaAdquirida.ts_ativacao),
          new Date(),
          licencaAdquirida.it_dias_duracao
        );
      
        this.licencaForm.setValue({ 
          fk_licenca: licencaAdquirida.fk_licenca || '',
          fk_cliente: licencaAdquirida.fk_cliente || '',
          ts_ativacao: new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-'),
          it_dias_duracao: diasRestantesDaLicenca || '',
          vc_ordem_servico: licencaAdquirida.vc_ordem_servico || '',
          vc_proposta: licencaAdquirida.vc_proposta || '',
          vc_nota_fiscal: licencaAdquirida.vc_nota_fiscal || '',
          vc_alvo_tecnico_cancelamento: licencaAdquirida.vc_alvo_tecnico_cancelamento || '',
          ts_expiracao: this.calcularDataExpiracao(
            licencaAdquirida.it_dias_duracao,
            licencaAdquirida.ts_expiracao
          ) || '',
          select_opcoes: ''
        });
      }
      
      
      this.validarIdentificador();
      this.adicionarCamposAdicionais(licencaAdquirida);
    });
  }

  calcularDataExpiracao(duracaoEmDias: any, dataAtivacao: any) {
    if (duracaoEmDias > 0) {
      const dataObj = new Date(dataAtivacao);
      dataObj.setDate(dataObj.getDate() + parseInt(duracaoEmDias, 10) + 1);
      const ano = dataObj.getFullYear();
      const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0');
      const dia = dataObj.getDate().toString().padStart(2, '0');
      const dataExpiracao = `${ano}-${mes}-${dia}`;
      return dataExpiracao;
    }
    return null;
  }

  adicionarCamposAdicionais(licencaAdquirida: any): void {
    var informacoesCamposAdicionais = JSON.parse(licencaAdquirida.js_informacoes_licenca);
    
    this.campos = [];

    Object.keys(informacoesCamposAdicionais).forEach((campo: string) => {
        var nomeCampo = campo.replace(/_/g, ' '); 
        const valorCampo = informacoesCamposAdicionais[campo] || ''; 

        
        this.licencaForm.addControl(campo, this.formBuilder.control(valorCampo, Validators.required));
        
        if (campo !== "Numero_de_serie" || this.tipoAlteracao === 'Editar') {
            this.campos.push({ 'nome_campo': nomeCampo, 'nome_formulario': campo });
        }
        
        
    });

    this.filtrarCampos(); 
  }

  setarDataExpiracao() {
    this.licencaForm.get('ts_ativacao')?.valueChanges.subscribe((dataAtivacao: any) => {
      if (this.licencaForm.get('it_dias_duracao')?.value) {
        this.licencaForm.get('ts_expiracao')?.setValue(this.calcularDataExpiracao(this.licencaForm.get('it_dias_duracao')?.value, this.licencaForm.get('ts_ativacao')?.value));
      };
    })
    this.licencaForm.get('it_dias_duracao')?.valueChanges.subscribe((dataAtivacao: any) => {
      if (this.licencaForm.get('ts_ativacao')?.value) {
        this.licencaForm.get('ts_expiracao')?.setValue(this.calcularDataExpiracao(this.licencaForm.get('it_dias_duracao')?.value, this.licencaForm.get('ts_ativacao')?.value));
      };
    })
  }

  alterarLicencaAdquirida(): void {
    this.licencaForm.removeControl('select_opcoes');
    this.licencaService.alterarLicencaAdquirirda(this.licencaAdquirida.sr_id, this.acharTipoDeAlteracaoNoBanco(this.tipoAlteracao), this.licencaForm.value).subscribe(
      (licenca: any) => {
        var token = licenca.token;
        Swal.fire({
          icon: 'success',
          title: 'Token gerado com sucesso!',
          confirmButtonText: 'Copiar token',
          confirmButtonColor: '#00AA5B',
          allowOutsideClick: false
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.copiarParaAreaDeTranferencia(token);
          } else if (result.isDenied) {
            this.enviarViaEmail(licenca);
          }
        })
      },
      (erro) => {
        this.alertService.error(erro);
      }
    );
  }

  copiarParaAreaDeTranferencia(token: any) {
    const elementoTemporario = document.createElement('textarea');
    elementoTemporario.value = token;
    document.body.appendChild(elementoTemporario);
    elementoTemporario.select();
    document.execCommand('copy');
    document.body.removeChild(elementoTemporario);
    this.alertService.success('Copiado para área de transferencia!');
    this.router.navigate(['configuracao/licencas']);
  }

  acharTipoDeAlteracaoNoBanco(tipoAlteracao: any): string | null {
    switch (tipoAlteracao) {
      case 'Renovar':
        return 'RENOVADO';
      case 'Trocar':
        return 'TROCADO';
      case 'Editar':
        return 'EDITADO';
      default:
        return null
    }
  }

  calcularDiasRestantesDaLicenca(dataAtivacao: any, dataNovaAtivacao: any, diasDaLicenca: any) {
    if(diasDaLicenca != 0){
      const diferencaEmMilissegundos = dataNovaAtivacao - dataAtivacao;
      const diferencaEmDias = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));
      return diasDaLicenca - diferencaEmDias;
    }
    return 0;
  }

  enviarViaEmail(licenca: any){
    var nomeDaLicenca = this.licencas.filter((licenca: any) => {
      return licenca.sr_id == this.licencaForm.get('fk_licenca')?.value
    })
    nomeDaLicenca = nomeDaLicenca[0]?.vc_nome;
    const dialogRef = this.dialog.open(EscolherUsuarioEnviarTokenComponent, {
      width: '35vw',
      data: [licenca, nomeDaLicenca]
    });
    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['configuracao/licencas']);
    });
  }

  validarIdentificador(): void {
    const propriedadesParaValidar = ['vc_nota_fiscal', 'vc_manutencao', 'vc_proposta'];
    
    let propriedadeValida = propriedadesParaValidar.filter(key => this.licencaAdquirida[key] && this.licencaAdquirida[key].trim() !== '');
    this.campoSelecionado = propriedadeValida[0];
    
    if (propriedadeValida.length === 1) {
      this.desabilitadoIdentificadorLicenca = false; 
      if (this.campoSelecionado && !this.licencaForm.contains(this.campoSelecionado)) {
        this.licencaForm.addControl(this.campoSelecionado, this.formBuilder.control('', Validators.required));
      }
      this.licencaForm.get(this.campoSelecionado)?.setValue(this.licencaAdquirida[this.campoSelecionado]);
      this.licencaForm.get('select_opcoes')?.setValue(this.campoSelecionado);
    } else {
      this.desabilitadoIdentificadorLicenca = false; 
      this.campoSelecionado = '';
    }
  }
  
  onChangeIdentificador(event: any): void {
    const novoCampoSelecionado = event.target.value;
  
    if (this.campoSelecionado && this.licencaForm.contains(this.campoSelecionado)) {
      this.licencaForm.get(this.campoSelecionado)?.setValue('');
    }
  
    this.campoSelecionado = novoCampoSelecionado;
  }
   
  adicionarCamposNoFormulario(dadosLicenca: any): void {
    dadosLicenca.campos_adicionais.forEach((campo: any) => {
      var nomeCampo = campo.vc_campo.replace(/ /g, "_");
      this.licencaForm.addControl(nomeCampo, this.formBuilder.control('', Validators.required));
      this.campos.push({ 'nome_campo': campo.vc_campo, 'nome_formulario': nomeCampo })
    });
  }

  filtrarCampos(): void {
    this.camposFiltrados = this.campos.filter((campo: any) => 
        campo.nome_campo !== 'Numero de série' || this.tipoAlteracao === 'Trocar'
    );
  }
}
